import { css, Global, withTheme } from '@emotion/react'
import * as React from 'react'

const GlobalCss = withTheme(() => (
  <Global
    styles={css`
      li {
        svg {
          fill: #3773b6;
        }
      }
    `}
  />
))

export default GlobalCss
